// NOTE: Ensure you also update the Cypress tests to intercept the correct paths
// See tests inside: cypress/cypress/e2e/pdp/*
export const SHIPPING_PREFERENCE_PUBLIC_ENDPOINT =
  '/fep/api/shipping-preference';
export const USER_SETTINGS_PUBLIC_ENDPOINT = '/fep/api/user-settings';
export const DELIVERY_DATES_PUBLIC_ENDPOINT = '/fep/api/delivery-dates';
export const ZERO_PAYMENT_CHECKOUT_ENDPOINT = '/fep/api/zero-payment-checkout';
export const PAYPAL_CHECKOUT_PAY_PUBLIC_ENDPOINT = '/fep/api/braintree-pay';
export const PAYPAL_CHECKOUT_TOKEN_PUBLIC_ENDPOINT = '/fep/api/braintree-token';
export const STRIPE_CHECKOUT_PAY_PUBLIC_ENDPOINT = '/fep/api/stripe-pay';
export const CART_MONOLITH_PUBLIC_ENDPOINT = '/fep/api/cart-monolith';
export const COUPON_MONOLITH_PUBLIC_ENDPOINT = '/fep/api/coupon-monolith';
export const ASSIGNED_COUPONS_PUBLIC_ENDPOINT = '/fep/api/assigned-coupons';
export const CART_ITEMS_PUBLIC_ENDPOINT = '/fep/api/cart-items';
export const LISTS_ARE_FAVORITED_PUBLIC_ENDPOINT =
  '/fep/api/lists/are-favorited';
export const LISTS_FAVORITE_PUBLIC_ENDPOINT = '/fep/api/lists/favorite';
export const LISTS_UNFAVORITE_PUBLIC_ENDPOINT = '/fep/api/lists/unfavorite';
export const FEATURED_PRODUCTS_PUBLIC_ENDPOINT =
  '/fep/api/homepage/featured-products';
export const FAN_ART_CAROUSEL_PUBLIC_ENDPOINT =
  '/fep/api/homepage/fan-art-carousel';
export const FEATURED_ARTISTS_PUBLIC_ENDPOINT =
  '/fep/api/about/featured-artists';
export const ADD_GIFT_CARD_PUBLIC_ENDPOINT = '/fep/api/gift-card/add';
export const SIMILAR_DESIGN_PUBLIC_ENDPOINT = '/fep/api/similar-designs';
export const USER_EVENTS_PUBLIC_ENDPOINT = '/fep/api/user-events';
export const SEARCH_RESULTS_FILTERS_PUBLIC_ENDPOINT =
  '/fep/api/search-results-filters';

// Artist follow/unfollow
export const ARTIST_FOLLOW_PUBLIC_ENDPOINT = '/fep/api/artists/follow';
export const ARTIST_UNFOLLOW_PUBLIC_ENDPOINT = '/fep/api/artists/unfollow';
